import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/app.scss";
import "./assets/styles/size.scss";
import App from "./App";
import theme from "./theme";
import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import axios from "axios";
import { createStandaloneToast } from "@chakra-ui/react";
import { Provider } from "react-redux";
import store from "./redux/store";
import ErrorBoundary from "./components/ErrorBoundary";
import { validateEnv } from "./utils/envValidation";

// Validate environment variables before starting the app
try {
  validateEnv();
} catch (error) {
  if (process.env.NODE_ENV === 'development') {
    console.warn(`Environment validation failed: ${error.message}`);
  }
}

const { ToastContainer, toast } = createStandaloneToast();

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.patch["Access-Control-Allow-Methods"] = "*";

axios.interceptors.request.use(
  (reqConfig) => {
    const reqConfiglocal = reqConfig;
    const token = localStorage.getItem("token");
    if (token) {
      reqConfiglocal.headers.Authorization = `Bearer ${token}`;
    }
    return reqConfiglocal;
  },
  (error) => {
    console.error('Request interceptor error:', error);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('Response interceptor error:', error);
    
    // In development mode, provide helpful error messages
    if (process.env.NODE_ENV === 'development') {
      if (error.code === 'ERR_NETWORK') {
        console.warn('Network error - API server may be unavailable');
      }
    }
    
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ErrorBoundary fallbackMessage="Application failed to load. Please refresh the page.">
      <ChakraProvider theme={theme}>
        <Provider store={store}>
          <ErrorBoundary fallbackMessage="A routing error occurred.">
            <App />
          </ErrorBoundary>
        </Provider>
        <ToastContainer />
      </ChakraProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
